<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
<template>
  <el-dialog
    v-dialogDrag
    title="新增车辆"
    :visible="visible"
    width="80%"
    @open="open"
    @close="close"
    :close-on-click-modal="false"
  >
    <div
      class="dialog_box"
      v-loading="loading"
      element-loading-text="请稍候..."
    >
      <el-row :gutter="20" class="form_body">
        <el-col :span="12">
          <p class="form_title">车辆信息</p>
          <el-form label-width="100px" :model="form" :rules="rules" ref="form">
<!--            <el-form-item label="车辆类型" prop="carType">-->
<!--              <el-select v-model="form.carType" placeholder="请选择" size="medium">-->
<!--                <el-option-->
<!--                  v-for="item in carTypeoptions"-->
<!--                  :key="item.value"-->
<!--                  :label="item.name"-->
<!--                  :value="item.value"-->
<!--                >-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="状态" prop="state">-->
<!--              <el-select v-model="form.state" placeholder="请选择" size="medium">-->
<!--                <el-option-->
<!--                  v-for="item in optionsCarState"-->
<!--                  :key="item.value"-->
<!--                  :label="item.name"-->
<!--                  :value="item.value"-->
<!--                >-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
            <el-form-item label="姓名" prop="name">
              <el-input v-model="form.carOwner" size="medium"></el-input>
            </el-form-item>
            <el-form-item label="车牌号码"  required>
              <el-input v-model="form.carNo" size="medium"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="phone">
              <el-input v-model="form.phone" size="medium"></el-input>
            </el-form-item>
<!--            <el-form-item label="积分" prop="score">-->
<!--              <el-input v-model="form.score" size="medium"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="来源" prop="carOrigin">-->
<!--              <el-select v-model="form.origin" placeholder="请选择" size="medium">-->
<!--                <el-option-->
<!--                  v-for="item in optionsCarOrigin"-->
<!--                  :key="item.value"-->
<!--                  :label="item.name"-->
<!--                  :value="item.value"-->
<!--                >-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->

<!--            <el-form-item label="备注" prop="note">-->
<!--              <el-input type="textarea" v-model="form.note" rows='10'></el-input>-->
<!--            </el-form-item>-->
          </el-form>
        </el-col>
      </el-row>
      <div class="submit_box">
        <el-button size="medium" @click="close" type="default">取消</el-button>
        <el-button size="medium" @click="submitForm('form')" type="primary"
          >提交</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
import dialog from "@/components/mixins/dialog";
import {getUserType,addSmartCar} from "./api/index"
export default {
  mixins: [dialog],
  data() {
    return {
      form: {},
      rules: {
        //表单校验规则
        // type: [{ required: true, message: "请选择人员类型", trigger: "blur" }],
        // name: [{ required: true, message: "请输入人员姓名", trigger: "blur" }],
      },
      carTypeoptions: [
        {"name":"临时车","value":"0"},
        {"name":"VIP车","value":"1"}
      ],
      optionsCarState:[
        {"name":"正常","value":"0"},
        {"name":"异常","value":"1"}
      ],
      optionsCarOrigin: [
        {"name":"手机端登记","value":"0"},
        {"name":"车辆系统同步","value":"1"},
        {"name":"临时添加","value":"2"}
      ],
    };
  },
  methods: {
    add() {
      this.loading = true;
      let tempData = Object.assign({}, this.form);
      addSmartCar(tempData)
          .then((res) => {
            if(res.data.code === 20000){
              this.$message({
                type: 'success',
                message: '添加成功'
              });
              this.loading = false;
              this.form = {}
              this.$emit('closeDialog')
            }else {
              this.$message({
                type: 'error',
                message: '添加失败：'+res.data.message
              });
              this.loading = false;
            }
          })
        .catch((err) => {
          this.loading = false;
          this.$alert(err.message, "添加失败", { type: "error" });
        });
    },
    getInfo(){
      getUserType('1002')
        .then((res) =>{
          this.options = res.data.data;
        })
      getUserType('1003')
        .then((res) =>{
          this.optionsCampus = res.data.data;
        })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.add();
        } else {
          return false;
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
  },
};
</script>
<style scoped>
.dialog_box .form_body {
  max-height: 50vh;
  overflow-y: auto;
}
.submit_box {
  text-align: center;
  border-top: 1px solid #409eff;
  padding-top: 20px;
}
.form_title {
  border-left: 5px solid #409eff;
  margin: 0;
  padding: 0 0 0 10px;
  margin-bottom: 15px;
  font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑";
  font-weight: 700;
  font-style: normal;
  text-align: left;
  color: #666666;
  font-size: 14px;
  height: 22px;
  line-height: 22px;
}
</style>


